export default Vue => {
  Vue.component("v-date-picker", () => import("./v-date-picker.vue"));
};
